import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  setItem<T extends string>(key: string, value: T): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string, fallback: string): string;
  getItem(key: string): string | null;
  getItem(key: string, fallback?: string): string | null {
    const value = localStorage.getItem(key);
    if (fallback === undefined) {
      return value;
    }
    return value || fallback;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
